__turbopack_context__.v({
  "bundle": "BundleStrip-module-scss-module__04zEPG__bundle",
  "description": "BundleStrip-module-scss-module__04zEPG__description",
  "header": "BundleStrip-module-scss-module__04zEPG__header",
  "headerText": "BundleStrip-module-scss-module__04zEPG__headerText",
  "heading": "BundleStrip-module-scss-module__04zEPG__heading",
  "linkDesktop": "BundleStrip-module-scss-module__04zEPG__linkDesktop",
  "linkMobile": "BundleStrip-module-scss-module__04zEPG__linkMobile",
  "list": "BundleStrip-module-scss-module__04zEPG__list",
  "plus": "BundleStrip-module-scss-module__04zEPG__plus",
  "plusIcon": "BundleStrip-module-scss-module__04zEPG__plusIcon",
  "plusTrack": "BundleStrip-module-scss-module__04zEPG__plusTrack",
  "product": "BundleStrip-module-scss-module__04zEPG__product",
  "root": "BundleStrip-module-scss-module__04zEPG__root",
});
